import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sortedIds: [],
  entities: {},
  filters: {},
  sorter: {},
  isLoaded: false,
  isSavingActive: false,
  search: '',
  page: 1,
  pageCount: 1,
  selectedCampaign: null,
  expandedRows: [],
  included: [],
}

const arcCampaignsSlice = createSlice({
  name: 'arcCampaigns',
  initialState,
  reducers: {
    fetchArcCampaignsSuccess: (state, { payload }) => {
      const entities = {}
      payload.campaigns.forEach(campaign => {
        entities[campaign.id] = campaign
      })
      return {
        ...state,
        isLoaded: true,
        page: payload.page,
        pageCount: payload.pageCount,
        entities,
        included: payload.included || [],
        sortedIds: payload.sortedIds,
      }
    },
    fetchArcCampaignsFailure: (state) => state,
    fetchArcCampaignDetailsSuccess: (state, { payload }) => ({
      ...state,
      selectedCampaign: payload.campaign,
      included: payload.included || state.included || [],
    }),
    fetchArcCampaignDetailsFailure: (state) => ({
      ...state,
      selectedCampaign: null,
    }),
    createArcCampaignSuccess: (state, { payload }) => {
      if (payload.data && payload.data.id) {
        return {
          ...state,
          entities: {
            ...state.entities,
            [payload.data.id]: payload.data,
          },
        }
      }
      return state
    },
    createArcCampaignFailure: (state) => state,
    updateArcCampaignSuccess: (state, { payload }) => {
      if (payload.data && payload.data.id) {
        return {
          ...state,
          entities: {
            ...state.entities,
            [payload.data.id]: payload.data,
          },
        }
      }
      return state
    },
    updateArcCampaignFailure: (state) => state,
    deleteCampaignSuccess: (state, { payload }) => {
      const { [payload.id]: deleted, ...remainingEntities } = state.entities
      return {
        ...state,
        entities: remainingEntities,
        sortedIds: state.sortedIds.filter(id => id !== payload.id),
      }
    },
    deleteCampaignFailure: (state) => state,
    toggleExpandedRow: (state, { payload }) => {
      const { campaignId } = payload
      const isExpanded = state.expandedRows.includes(campaignId)
      return {
        ...state,
        expandedRows: isExpanded
          ? state.expandedRows.filter(id => id !== campaignId)
          : [...state.expandedRows, campaignId],
      }
    },
    saveFiltersAndSorter: (state, { payload = {} }) => ({
      ...state,
      search: payload.search,
      filters: payload.filters || initialState.filters,
      sorter: payload.sorter || initialState.sorter,
    }),
    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
    clearData: () => initialState,
  },
})

export default arcCampaignsSlice